import { CUSTOM_FIELDS_CREATE, CUSTOM_FIELDS_REMOVE } from '../actions/custom_fields';

type ICustomField = {
  new?: number;
  id: number | string;
};
export type ICustomFieldsStoreState = {
  new_fields: Array<ICustomField>;
};

const defaultState: ICustomFieldsStoreState = {
  new_fields: [],
};

const generateNewField = () => ({ new: 1, id: Math.random().toString(36).substring(7) });

const reducer = (state = defaultState, action): ICustomFieldsStoreState => {
  switch (action.type) {
    case CUSTOM_FIELDS_CREATE:
      return {
        ...state,
        new_fields: state.new_fields.concat(generateNewField()),
      };

    case CUSTOM_FIELDS_REMOVE:
      return {
        ...state,
        new_fields: state.new_fields.filter(({ id }) => id !== action.value),
      };
  }

  return state;
};

export default reducer;
